import { jsx as _jsx } from "react/jsx-runtime";
import { Shimmer } from '@fluentui/react';
/** Renders a shimmer effect (meant for when mecontrol is loading but isn't loaded yet) */
export const MeControlShimmer = () => (_jsx("div", { id: 'meControl', style: { width: '100%', height: '100%' }, children: _jsx(Shimmer, { styles: {
            root: {
                borderRadius: '32px',
                width: '32px',
                overflow: 'hidden',
                margin: '8px',
            },
            shimmerWrapper: { height: '32px' },
        } }) }, 'meControl'));
